import React, { useEffect, useState } from 'react';
import { ArrowRight, X } from 'lucide-react';

export default function StickyCTA({ openLaunch }) {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('freddy_sticky_cta_dismissed') === '1');

  useEffect(() => {
    if (dismissed) return;
    const onScroll = () => setVisible(window.scrollY > 900);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [dismissed]);

  if (dismissed || !visible) return null;

  const dismiss = () => {
    sessionStorage.setItem('freddy_sticky_cta_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] animate-fade-in-up" data-testid="sticky-cta-bar">
      <div className="bg-[#111827]/95 backdrop-blur-xl border-t border-[#FF4343]/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-3">
          <p className="hidden md:block text-sm text-[#9CA3AF]">
            <span className="text-white font-semibold">Ready to put real executives behind your brand?</span>{' '}
            Managed end-to-end. Pay only on approval.
          </p>
          <div className="flex items-center gap-2 sm:gap-3 flex-1 md:flex-initial justify-end">
            <button type="button" data-testid="sticky-cta-proposal-btn"
              onClick={() => document.getElementById('get-proposal')?.scrollIntoView({ behavior: 'smooth' })}
              className="rounded-full border-2 border-white/25 text-white hover:border-white px-4 sm:px-5 py-2 text-xs font-bold transition-all whitespace-nowrap">
              Get a Proposal
            </button>
            <button type="button" data-testid="sticky-cta-book-btn"
              onClick={() => openLaunch('sticky_bar')}
              className="rounded-full border-2 border-[#FF4343] bg-[#FF4343] text-[#090E33] hover:bg-[#E03030] px-4 sm:px-5 py-2 text-xs font-bold inline-flex items-center gap-1.5 transition-all whitespace-nowrap">
              Book a Walkthrough <ArrowRight className="w-3.5 h-3.5" />
            </button>
            <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="sticky-cta-dismiss"
              className="text-[#6B7280] hover:text-white p-1 transition-colors">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
